export class Answers {
    dateOfBirth?: Date;
    nationalInsuranceNumber?: string;
    tenancyStartDate?: Date;
    rentCharge?: string;
    rentFrequency?: string;

    private today = new Date();

    // Date validation constraints
    dateOfBirthMinDate = new Date(this.today.getFullYear() - 102, this.today.getMonth(), this.today.getDate());
    dateOfBirthMaxDate = new Date(this.today.getFullYear() - 16, this.today.getMonth(), this.today.getDate());
    tenancyStartDateMinDate = new Date(this.today.getFullYear() - 80, this.today.getMonth(), this.today.getDate());
    tenancyStartDateMaxDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
}
